import React from "react";
import ContactClasses from "./contact.module.css";
import Layout from "Components/Layouts/Common/common";
import { useForm, SubmitHandler } from "react-hook-form";
import CustomButton from "Components/Button";
import ContactCards from "Components/Contact_Us/Cards";
import Locations from "Assets/contact/locations.png";
type Inputs = {
    example: string;
    exampleRequired: string;
};
function Contact() {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<Inputs>();
    const onSubmit: SubmitHandler<Inputs> = (data) => console.log(data);
    return (
        <Layout>
            <div className={ContactClasses["Container"]}>
                <header>
                    <h3>Contact Us</h3>
                </header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h3>Get In Touch</h3>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Name</label>
                        <input type="text" placeholder="Type Here" />
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Email</label>
                        <input type="email" placeholder="Enter Email" />
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Phone Number</label>
                        <input type="email" placeholder="Enter Your Number" />
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Your website</label>
                        <input type="email" placeholder="Enter Your website" />
                    </div>
                    <div
                        className={`${ContactClasses["form-control"]} ${ContactClasses["form-control-textarea"]}`}>
                        <label htmlFor="">Message</label>
                        <textarea placeholder="Enter Your Message" />
                    </div>
                    <CustomButton
                        Title="Submit"
                        onClick={() => {}}
                        Theme="Dark"
                    />
                </form>
                <div className={ContactClasses["Cards"]}>
                    <h3>
                        Contact <span>Info</span>
                    </h3>
                    <ContactCards />
                </div>
                <div className={ContactClasses["locations"]}>
                    <h3>
                        Our <span>Locations</span>
                    </h3>
                    <img src={Locations} alt="Locations" />
                </div>
            </div>
        </Layout>
    );
}

export default Contact;
